import { STEPS } from "../hooks/useVerificationFlow";
import MethodStep from "./components/MethodStep";
import CodeStep from "./components/CodeStep";
import LockedStep from "./components/LockedStep";

import "./styles.scss";

/**
 * Pure switch over the flow's step. Every prop comes from useVerificationFlow.
 */
export default function VerificationView({
    step,
    methods,
    unverified,
    channel,
    target,
    code,
    codeStatus,
    message,
    sending,
    verifying,
    verifyingPhone,
    lockedUntil,
    resendIn,
    expiresIn,
    canResend,
    codeInputRef,
    requestCode,
    verifyPhone,
    resend,
    chooseAnother,
    handleCodeChange,
    handleCodeComplete,
}) {
    if (step === STEPS.LOCKED) {
        return <LockedStep lockedUntil={lockedUntil} />;
    }

    if (step === STEPS.CODE) {
        return (
            <CodeStep
                channel={channel}
                target={target}
                code={code}
                codeStatus={codeStatus}
                message={message}
                sending={sending}
                verifying={verifying}
                resendIn={resendIn}
                expiresIn={expiresIn}
                canResend={canResend}
                codeInputRef={codeInputRef}
                onCodeChange={handleCodeChange}
                onCodeComplete={handleCodeComplete}
                onResend={resend}
                onChooseAnother={chooseAnother}
            />
        );
    }

    return (
        <MethodStep
            methods={methods}
            unverified={unverified}
            channel={channel}
            message={message}
            sending={sending}
            verifyingPhone={verifyingPhone}
            resendIn={resendIn}
            onChoose={requestCode}
            onVerifyPhone={verifyPhone}
        />
    );
}
